import { useFetchFloorPlan } from '@jooxter/floors';
import { JxtNoFloorPlan } from '@jooxter/ui';
import { IJxtLocateResource } from './types';
import { useFetchResource, useFetchResourceStatus } from '@jooxter/resources';
import JxtFloorPlanPictos from '../JxtFloorPlanPictos';
import { FloorPlanPictoTypeEnum } from '../../hooks';
import { useMemo } from 'react';

export const JxtLocateResource = ({ resourceId, width, height, statusOptions, focus = false }: IJxtLocateResource) => {
  const { resource } = useFetchResource(resourceId);
  const { floorPlan } = useFetchFloorPlan(resource?.floor?.id);
  const { status } = useFetchResourceStatus(statusOptions);

  const resourceWithStatus = useMemo(() => {
    if (!resource) return null;
    return {
      ...resource,
      state: status ? { ...resource.state, ...status } : resource.state,
      resourceTypeId: resource.resourceType.id,
    };
  }, [resource, status]);

  if (!resourceWithStatus) {
    return null;
  }

  return floorPlan?.image ? (
    <JxtFloorPlanPictos
      floorPlan={floorPlan}
      width={width}
      height={height}
      resources={[resourceWithStatus]}
      type={FloorPlanPictoTypeEnum.ResourceState}
      focusResourceId={focus ? resourceWithStatus.id : undefined}
    />
  ) : (
    <JxtNoFloorPlan />
  );
};
